import React from "react";
import DeleteUserListData from "../../../components/userlistdata/deleteuserlistdata";

const DeletedUsers = () => {
  return(
    <>
      <DeleteUserListData/>
    </>
  );
};

export default DeletedUsers;
